/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function dateToSillySearchFormat(date: Date): string {
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${month}/${day}/${year}`;
}
